// src/i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'cn',
  messages: {
    'cn': require('./config/cn.json'),
    'en': require('./config/en.json'),
    'Hant': require('./config/Hant.json')

  }
})

export default i18n